import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import appRouterService from '@/services/route/appRouterService';
import {selectFlexPuff} from '@/state/selectors/deviceSettings';

import {createSwitchSetting} from '../../components/SwitchSetting';

export const createFlexPuffSetting = () =>
    createSwitchSetting({
        settingType: AEM_DEVICE_SETTINGS_TYPES.FLEX_PUFF,
        selector: selectFlexPuff,
        onNavigate: () => appRouterService.forwardToFlexPuffPage(),
    });
